import React, { Component } from "react";
import PropTypes from "prop-types";
import { CardContainer } from "./style";
import RecentCharityCard from "./RecentCharityCard/RecentCharityCard";
import SavedCharityCard from "./SavedCharityCard/SavedCharityCard";
import PopupCard from "./PopupCard/PopupCard";
import SearchCharityCard from "./SeachCharityCard/SeachCharityCard";
import SearchGeminiCard from "./SearchGeminiCard/SearchGeminiCard";

export default class RenderCard extends Component {
  renderElement = props => {
    switch (props.component) {
      case "RecentCharityCard":
        return <RecentCharityCard {...props} />;
      case "SavedCharityCard":
        return <SavedCharityCard {...props} />;
      case "PopupCard":
        return <PopupCard {...props} />;
      case "SearchCharityCard":
        return <SearchCharityCard {...props} />;
      case "SearchGeminiCard":
        return <SearchGeminiCard {...props} />;
      default:
        break;
    }
  };
  render() {
    const { index } = this.props;
    return (
      <div>
        <CardContainer index={index}>
          {this.renderElement({ ...this.props })}
        </CardContainer>
      </div>
    );
  }
}

RenderCard.propTypes = {
  component: PropTypes.string,
  data: PropTypes.shape({
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    addressLine3: PropTypes.string,
    charityId: PropTypes.number,
    charityName: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
    ein: PropTypes.string,
    granteeOrgAliasId: PropTypes.number,
    granteeOrgs: PropTypes.any,
    interestArea: PropTypes.any,
    isExisting: PropTypes.bool,
    isPending: PropTypes.bool,
    location: PropTypes.string,
    purpose: PropTypes.any,
    savedCharitieList: PropTypes.any,
    state: PropTypes.string,
    success: PropTypes.any,
    zip: PropTypes.string,
  }),
  index: PropTypes.number,
  pendingCharityHandler: PropTypes.func,
  removeSavedCharity: PropTypes.func,
}
